import React from 'react';
import styled, { keyframes, css } from 'styled-components';
import Analysis from '../assets/images/icons/Analysis';
import CloseIcon from '@material-ui/icons/Close';

const waveAnimation = keyframes`
  0% {
    background-position-x: 0%;
  }
  100% {
    background-position-x: 100%;
  }
`;

const getHoverStyles = props => {
  if (props.backgroundColor?.includes('#ff')) {
    // Kırmızı tonları için
    return css`
      background: #cc0044;
      box-shadow: 0 6px 12px rgba(204, 0, 68, 0.4);
    `;
  }
  // Mavi buton için özel stil
  return css`
    background: #EAB00A;
    transform: translateY(-2px);
    box-shadow: 0 8px 15px rgba(234, 176, 10, 0.3);
  `;
};

const getButtonStyles = props => {
  if (props.backgroundColor?.includes('#ff')) {
    // Kırmızı buton için özel stil
    return css`
      background: ${props.backgroundColor};
      box-shadow: 0 4px 8px rgba(255, 0, 85, 0.3);
      &:hover .wave {
        top: 35%;
      }
    `;
  }
  // Mavi buton için özel stil
  return css`
    background: ${props.backgroundColor || '#3189ec'};
    box-shadow: 0 4px 8px rgba(49, 137, 236, 0.2);
    &:hover .wave {
        top: 40%;
    }
  `;
};

const ButtonContainer = styled.button`
  width: ${props => props.width || '250px'};
  height: ${props => props.height || '60px'};
  border: none;
  border-radius: 10px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.4s ease;
  padding: ${props => props.text ? '0 20px' : '0'};
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-family: 'Poppins', sans-serif;

  ${props => getButtonStyles(props)}

  &:hover {
    ${props => getHoverStyles(props)}
  }

  &:hover ${props => props.iconColor ? `svg { fill: ${props.iconColor} }` : ''};
`;

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${props => props.text ? '10px' : '0'};
  z-index: 1;
  width: 100%;
  height: 100%;
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${props => !props.text ? '100%' : 'auto'};
  height: ${props => !props.text ? '100%' : 'auto'};
  
  svg {
    width: ${props => !props.text ? '24px' : '24px'};
    height: ${props => !props.text ? '24px' : '24px'};
    fill: ${props => props.iconColor || 'white'};
    transition: fill 0.3s ease;
  }
`;

const Text = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${props => props.textColor || 'black'};
  z-index: 1;
  position: relative;
  margin: 0;
  padding: 0;
  line-height: 1;
`;

const Wave = styled.div`
  position: absolute;
  width: 250%;
  height: ${props => props.backgroundColor?.includes('#ff') ? '100%' : '85%'};
  background: ${props => props.backgroundColor?.includes('#ff')
    ? `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 800 88.7'%3E%3Cpath d='M800 56.9c-155.5 0-204.9-50-405.5-49.9-200 0-250 49.9-394.5 49.9v31.8h800v-.2-31.6z' fill='%23ff3366'/%3E%3C/svg%3E")`
    : `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 800 88.7'%3E%3Cpath d='M800 56.9c-155.5 0-204.9-50-405.5-49.9-200 0-250 49.9-394.5 49.9v31.8h800v-.2-31.6z' fill='%23846200'/%3E%3C/svg%3E")`};
  background-size: 50% 100%;
  background-repeat: repeat-x;
  top: ${props => props.text ? (props.backgroundColor?.includes('#ff') ? '95%' : '90%') : '100%'};
  left: -75%;
  animation: ${waveAnimation} 3s linear infinite;
  transition: 0.4s ease-in-out;
  pointer-events: none;
  opacity: 0.6;
`;

const WavyButton = ({ text, onClick, backgroundColor, textColor, width, height, iconColor, icon: IconComponent }) => {
  return (
    <ButtonContainer
      onClick={onClick}
      backgroundColor={backgroundColor}
      width={width}
      height={height}
      iconColor={iconColor}
      text={text}
    >
      <ContentWrapper text={text}>
        {IconComponent !== null && (
          <IconWrapper iconColor={iconColor || textColor} text={text}>
            {IconComponent ? <IconComponent /> : <Analysis />}
          </IconWrapper>
        )}
        {text && <Text textColor={textColor}>{text}</Text>}
      </ContentWrapper>
      {text && <Wave className="wave" backgroundColor={backgroundColor} text={text} />}
    </ButtonContainer>
  );
};

export default WavyButton; 